import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import type { SelfDescribingJson } from '@snowplow/browser-tracker'

import { getCookies } from 'lib/web/cookieUtils'
import { DEFAULT_LOCALE } from 'i18n/util/locale'

export function languageContext(): SelfDescribingJson {
  return comluxgroup.createLanguage_1_0_0({
    language: getLanguageFromCookies(),
  })
}

export function getLanguageFromCookies(): string {
  return getCookies().lang || DEFAULT_LOCALE
}
